import { render } from 'preact';
import { App } from './App';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import './styles/main.css';

const root = document.getElementById('app');
if (root) {
  render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>,
    root
  );
}
